import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { refundQueries, workspaceQueries } from '../../../../../Actions'

/**
 * 환불 기록이 바뀐 뒤 다시 읽어야 하는 것들 (aipark-front #266)
 *
 * 대장만 갱신하면 결제 건 목록의 "환불 상태" 태그가 낡은 채 남는다 — 그 값은
 * `refundQueries.invoiceView` 에서 오고, 워크스페이스 상세의 구독 상태는 후속 조치
 * (구독 즉시 비활성 전환·직전 약정 복원)로 바뀐다. 셋을 같이 무효화해야 화면이 한 상태가 된다.
 */
export default function useInvalidateRefunds(workspaceId: number) {
  const queryClient = useQueryClient()

  return useCallback(
    () =>
      Promise.all([
        // `_def` = 대장·결제 건별 현황·사건 조회 전부. 어느 행이 바뀌었는지 따지지 않는다
        queryClient.invalidateQueries({ queryKey: refundQueries._def }),
        queryClient.invalidateQueries({ queryKey: workspaceQueries.detail(workspaceId).queryKey }),
      ]),
    [queryClient, workspaceId],
  )
}
